export default __webpack_public_path__ + "static/media/25-1.303bbe35.mp3";